import React from 'react'
import {Row, Col, message, Modal, Input} from "antd"
import './index.less'
import Util from '../../utils/utils'
import {connect} from 'react-redux'
import NoticeEmitter from "../../utils/NoticeUtil";

import {removeToken} from "../../utils/cookie";
import {_logout, userPassChange, shopStatusChange, getShopInfo} from "../../constants/api";
import Switch from "antd/es/switch";

class Header extends React.Component {
  state = {
    shopId: 0,
    userName: '',
    modifyPwdModal: false,//修改密码弹窗
    name: '',//登录名
    pwd: '',//密码
    pwdNew: '',//确认密码

    dataStatus: -100
  }

  componentWillUnmount() {
    NoticeEmitter.removeListener('SHOPID_KEY', () => {});
  }

  componentWillMount() {
    setInterval(() => {
      let sysTime = Util.formateDate(new Date().getTime());
      this.setState({
        sysTime
      })
    }, 1000)
  }

  componentDidMount() {
    let storage = window.localStorage;
    let userName = storage.getItem('USER_NAME');
    let shopId = storage.getItem('SHOP_ID');
    this.setState({userName: userName, name: userName, shopId: shopId}, ()=> {
      this.getShopInfo(shopId)
    })
  }

  logOut = () => {
    _logout().then((res) => {
      console.log(res)
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          removeToken();
          // this.props.history.push('/')
        } else {
          message.error(data.msg)
        }
      }

    }).catch(error => {
      message.error(error.toString())
    })
  }

  modifyPass = () => {
    this.setState({modifyPwdModal: true})
  }

  onchangeName = (e) => {
    this.setState({
      name: e.target.value
    })
  }
  onchangePwd = (e) => {
    this.setState({
      pwd: e.target.value
    })
  }
  onchangePwdNew = (e) => {
    this.setState({
      pwdNew: e.target.value
    })
  }
  onModifyPwdOk = () => {
    userPassChange({
      nickName: this.state.name,
      pass: this.state.pwd,
      passNew: this.state.pwdNew
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('操作成功')
          this.setState({
            modifyPwdModal: false
          }, () => {
            removeToken();
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  onModifyPwdCancel = () => {
    this.setState({modifyPwdModal: false})
  }

  getShopInfo = (shopId) => {
    getShopInfo({
      id: shopId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let info = data.data
          this.setState({dataStatus: info.dataStatus})
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  changeShopStatus = (txt) => {
    switch (txt) {
      case 'open':
        this.changeShopS(1)
        break;
      case 'close':
        this.changeShopS(2)
        break;
    }
  }

  onChangeChecked=(value)=>{
    console.log(value)
    if (value == true){
      this.changeShopStatus('open')
      // this.setState({dataStatus:-1})
    } else {
      this.changeShopStatus('close')
      // this.setState({dataStatus:10})
    }
  }

  changeShopS = (isClose) => {
    shopStatusChange({
      shopId: this.state.shopId,
      isClose: isClose
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (isClose == 1) {
            message.success('店铺已营业')
            this.getShopInfo(this.state.shopId)
          } else {
            message.success('店铺已打烊')
            this.getShopInfo(this.state.shopId)
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  render() {
    return (
      <div className="header-content">
        <Row className='header-row' >
          <Col className='shop-col'>
            <div className='shop-continaer'>
              {/*<span>店名：</span>*/}
              <span style={{fontSize: '24px', color: '#000000'}}>{this.state.userName}</span>
              <span style={{fontSize: 14, color: '#000000', marginLeft: 40}}>
                  店铺状态：
                {
                  this.state.dataStatus == 10 ?
                      <span style={{fontSize: 16, color: '#20b605', fontWeight: 'bold'}}>营业中</span> :
                      this.state.dataStatus == -10 ?
                          <span style={{fontSize: 16, color: '#ff0000', fontWeight: 'bold'}}>处罚中</span> :
                          this.state.dataStatus == -1 ?
                              <span style={{fontSize: 16, color: '#FF0000', fontWeight: 'bold'}}>打烊了</span> :
                              this.state.dataStatus == 1 ?
                                  <span style={{fontSize: 16, color: '#20b605', fontWeight: 'bold'}}>审核通过</span> :
                                  this.state.dataStatus == -100 ?
                                      <span style={{fontSize: 16, color: '#FF0000', fontWeight: 'bold'}}>已关店</span> : ''
                }

                </span>
            </div>
            <div className='shop-continaer2'>
              <div>
                <Switch style={{marginRight: 20}}
                        checkedChildren="营业"
                        unCheckedChildren="打烊"
                        checked={this.state.dataStatus == 10 ? true:false}
                        onChange={this.onChangeChecked} />
              </div>
              <div>
                {/*<span style={{fontSize: 14, color: '#000000', marginRight: 20}}><span*/}
                {/*    style={{fontSize: 14, color: '#000000', fontWeight: 'bold'}}>{this.state.userName}</span></span>*/}
                {/*<a style={{marginRight: 20, color: '#20b605'}} onClick={this.changeShopStatus.bind(this, 'open')}>营业</a>*/}
                {/*<a style={{marginRight: 50, color: '#FF0000'}} onClick={this.changeShopStatus.bind(this, 'close')}>打烊</a>*/}
                <a style={{marginRight: 20}} onClick={this.modifyPass.bind(this)}>修改登录密码</a>
                <a onClick={this.logOut.bind(this)}>退出登录</a>
              </div>
            </div>
          </Col>
        </Row>

        <Modal
            title='修改密码'
            width={'280px'}
            destroyOnClose={true}
            visible={this.state.modifyPwdModal}
            onOk={this.onModifyPwdOk.bind(this)}
            onCancel={this.onModifyPwdCancel.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <Input style={{width: '200px'}} defaultValue={this.state.name} placeholder={'请输入登录名'} onChange={this.onchangeName}/>
            <Input style={{width: '200px', marginTop: 10}} defaultValue={''} type={'password'} placeholder={'请输入原密码'} onChange={this.onchangePwd}/>
            <Input style={{width: '200px', marginTop: 10}} defaultValue={''} type={'password'} placeholder={'请输入新密码'} onChange={this.onchangePwdNew}/>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    menuName: state.menuName
  }
};
export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.js